"use client";

import { WhoItsForSection } from "@/components/sections/who-its-for";
import { whoItsFor } from "@/lib/data/services-competitive-intelligence";

export function WhoItsFor() {
  return (
    <WhoItsForSection
      eyebrow={whoItsFor.eyebrow}
      title={whoItsFor.title}
      accent={whoItsFor.accent}
      gridCols={whoItsFor.gridCols}
      segments={whoItsFor.segments}
    />
  );
}